<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 three-dot-color ml-auto" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" @click="is_show = !is_show">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
  </svg>
  <div v-if="is_show" v-click-outside="onClickOutside"
    class="bg-white popup-shadow py-4 absolute right-20 rounded-md box-border z-50">
    <ul class="w-full">

      <li class="text-black px-4 cursor-pointer hover:bg-gray-200">
        <a target="_blank" @click="openPopup(menuCycle.id, week_date, 'weekly_contribution')">Weekly Contribution
          Report</a>
      </li>

      <li class="text-black px-4 cursor-pointer hover:bg-gray-200">
        <a target="_blank" @click="openPopup(menuCycle.id, week_date, 'weighted_analysis')">Weighted Analysis Report</a>
      </li>

      <li class="text-black px-4 cursor-pointer hover:bg-gray-200">
        <inertia-link
          :href="route('menu-cycle-edit', menuCycle.id) + '?month=' + searchForm.month + '&year=' + searchForm.year + '&mealtype=' + searchForm.meal_type + '&agerange=' + searchForm.age_grade_offering + '&guide_line_id=' + searchForm.guide_line_id + '&offering_id=' + searchForm.offering_id + '&site=' + searchForm.site + '&days=' + searchForm.day + '&weekDate=' + week_date + '&weekNumber=' + week + '&type=' + searchForm.type + '&is_update=1' + '&isExcludedWeek=true'">Edit
          Menu Week</inertia-link>
      </li>

      <li class="text-black px-4 cursor-pointer hover:bg-gray-200">
        <inertia-link onclick="return confirm('Are you sure want to delete menu week?')"
          :href="route('menu-cycle-delete', menuCycle.id) + '?month=' + searchForm.month + '&id=' + menuCycle.id + '&year=' + searchForm.year + '&mealtype=' + searchForm.meal_type + '&agerange=' + searchForm.age_grade_offering + '&days=' + searchForm.day + '&weekNumber=' + week + '&guide_line_id=' + searchForm.guide_line_id + '&site=' + searchForm.site + '&type=' + searchForm.type + '&offering_id=' + offeringId()">Delete
          Menu Week</inertia-link>
      </li>

      <!-- <li @click="importWeekCycleModalOpen" class="hover:bg-gray-200 px-4 text-black cursor-pointer">Import Menu Week</li> -->
    </ul>
  </div>
</template>
<script>
import vClickOutside from "click-outside-vue3";
import JetDialogModal from '@/Jetstream/DialogModal';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';

export default {

  directives: {
    clickOutside: vClickOutside.directive
  },

  props: ['menuCycle', 'searchForm', 'week_date', 'week', 'isExcludedWeek'],

  components: {
    vClickOutside,
    JetDialogModal,
    JetSecondaryButton
  },

  data() {
    return {
      is_show: 0,
      importWeekCycleModal: false,

      siteFilterImport: '',
      graderangeFilterImport: '',
      mealFilterImport: '',
      currentWeek: '',
      meal_types: []
    };
  },
  mounted() {
    let date = new Date();

    //this.currentWeek = date.getWeek();
  },

  methods: {

    offeringId() {
      this.searchForm.offering_id = (this.searchForm.offering_id === null) ? '' : this.searchForm.offering_id;
      return this.searchForm.offering_id;
    },


    async openPopup(menuCycle_id, week_date, reportType) {

      console.log('searchForm', this.searchForm);
      // Specify the URL you want to open in the popup window
      var url = route('export-weekly-contribution-report') + '?menuCycle=' + menuCycle_id + '&weekDate=' + week_date + '&is_html=1';

      if (reportType === 'weighted_analysis') {
        url = route('export-weight-analysis-report') + '?menuCycle=' + menuCycle_id + '&weekDate=' + week_date;
      }
      url = url + '&site='+this.searchForm.site + '&offering_id=' + this.searchForm.offering_id;
      // Define the window's properties (size, position, etc.)
      const width = 600;
      const height = 400;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;

      // Open the URL in a popup window
      const popup = window.open(url, 'PopupWindow', `width=${width},height=${height},left=${left},top=${top}`);
      //   window.document.write(url);
      // Focus the popup window (optional)
      if (popup) {
        popup.focus();

        popup.print();
      }
    },

    onClickOutside(event) {
      this.is_show = 0;
    },

    importWeekCycleModalOpen() {
      this.importWeekCycleModal = true;
      this.is_show = 0;
    },


    onSiteChangeCalendarFilterImport() {
      if (this.siteFilterImport == "") {
        this.$inertia.reload();
      }
    },


    onGradeRangeChangeCalendarFilterImport() {
      if (this.graderangeFilterImport == "") {
        this.$inertia.reload();
      } else {
        axios.post('/menu-cycle-get-meal-types', { grade_range: this.graderangeFilterImport })
          .then((response) => {
            this.meal_types = response.data;
          })
          .catch(error => console.error(error));
      }
    },


    onMealChangeCalendarFilterImport() {
      if (this.mealFilterImport == "") {
        this.$inertia.reload();
      }
    },


    importWeekCycleFilterMethod() {
      if (this.siteFilterImport == "") {
        this.$toast.warning('Select Site Value!');
      } else if (this.graderangeFilterImport == "") {
        this.$toast.warning('Select Grade Range Value!');
      } else if (this.mealFilterImport == "") {
        this.$toast.warning('Select Meal Value!');
      } else {

      }
    },

  },
};

</script>

<style>
.menu-day-background {
  background-color: #cbcbcb;
}

.box-sizing {
  width: 100px;
  height: 60px;
}

.popup-shadow {
  box-shadow: 0px 5px 10px #0000005e;
}
</style>
